import React, {Fragment} from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {ButtonPrimary, ButtonIconPrimary} from '@homeaway/react-buttons';
import {clickedControl} from '../edap';
import {PLUS__16} from '@homeaway/svg-defs';
import {SVGIcon} from '@homeaway/react-svg';
import {withTranslationsAsProps} from '../../../components/translations';
import createTripboardActions from '../actions';

export const EDAP_LABEL = 'tripboard.create.control.button';

const handleClick = (callback) => () => {
    /* dispatch edap */
    clickedControl(EDAP_LABEL);
    callback();
};

export const CreateTripboardButton = ({title, openModal, isMobile = false}) => {
    const onClick = handleClick(openModal);
    const buttonLabel = (<Fragment><SVGIcon inline markup={PLUS__16}/><span>{title}</span></Fragment>);
    if (isMobile) {
        return <ButtonIconPrimary label={buttonLabel} onClick={onClick} svgMarkup={PLUS__16} circle size={'xs'}/>;
    }
    return <ButtonPrimary onClick={onClick} label={buttonLabel}/>;
};

const mapDispatchToProps = {
    openModal: createTripboardActions.openModal
};

export default compose(withTranslationsAsProps({'tripboards.main.empty.create': 'title'}), connect(null, mapDispatchToProps))(CreateTripboardButton);



// WEBPACK FOOTER //
// ./src/universal/tripboard/create-tripboard-controls/components/create-tripboard-button.js